import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import 'dropzone/dist/min/dropzone.min.css'
import { isString } from "lodash"
import React, { Component } from 'react'
import DropzoneComponent from 'react-dropzone-component'
import 'react-dropzone-component/styles/filepicker.css'
import EventBus from '../EventBus.js'
import './dropzone.scss'

class ImageUploaderDropZone extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            images: this.props.images || [],
            accountId: this.props.accountId || '',
            alreadyAdded: this.props.alreadyAdded || true,
            showFiletypeIcon: this.props.showFiletypeIcon ?? true,
        }
        const defaultCallback = () => { }
        this.onUpdateImageList = this.props.onUpdateImageList || defaultCallback
        this.maxFiles = this.props.maxFiles ?? 1
        this.dropZone = null
        this.addedFile = this.addedFile.bind(this)
        this.removedFile = this.removedFile.bind(this)
        this.initDropZone = this.initDropZone.bind(this)
        this.maxFilesExceeded = this.maxFilesExceeded.bind(this)
        this.handleEvents = this.handleEvents.bind(this)
        EventBus.listen(EventBus.TopicUploaderImagesLoaded, 'image-uploader-dropzone', this.handleEvents)
    }

    /* componentWillReceiveProps(nextProps) {
        this.setState({
            alreadyAdded: nextProps.alreadyAdded === true,
        })

        if (!this.state.alreadyAdded && nextProps.images &&
            nextProps.images.length > 0 && nextProps.images.length > this.state.images.length) {
            this.setState({
                alreadyAdded: true,
            })

            this.setState({
                images: nextProps.images,
            }, this.updateUploadedImages)
        }
    } */

    componentDidMount() {
        const session = AppContext.getSession()
        if (session && session.attributes.impersonateAccountId) {
            this.setState({
                accountId: session.attributes.impersonateAccountId,
            })
        }
    }

    handleEvents(event) {

        //if the event.getData().images returns an array of image Ids -> fetch the images objects and set it to the images state
        //else event.getData().images should return already an array of images objects which we can set to the images state

        const imagesIds = event.getData().images
        if (isString(imagesIds[0]) && imagesIds.length > 0) {
            Promise.all(imagesIds.map(imageId => AppContext.getApiClient().get('/images/' + imageId)))
                .then((images) => {
                    this.setState({
                        images,
                    }, () => { this.updateUploadedImages() })
                });
        } else {
            this.setState({
                images: event.getData().images
            }, () => {
                this.updateUploadedImages()
            })
        }

    }

    addedFile(file) {
        try {
            const json = JSON.parse(file.xhr.response)
            this.setState(prevState => ({
                images: [...prevState.images, json]
            }))
            this.onUpdateImageList(this.state.images)
        } catch(e) {
            alert(e)
        }
    }

    removedFile(file) {
        const json = JSON.parse(file.xhr.response)
        if (!(AppContext && AppContext.getUserLoggedIn())) {
            this.state.images = this.state.images.filter(image => image.id != json.id)
            this.onUpdateImageList(this.state.images)
        } else {
            AppContext.getApiClient().delete('/images/' + json.id).then(res => {
                this.state.images = this.state.images.filter(image => res.id != image.id)
                this.onUpdateImageList(this.state.images)
            })
        }
    }

    updateUploadedImagesFromImages(images) {
        this.setState({
            images,
        }, this.updateUploadedImages)
    }

    sending(file, xhr, formData) {
        formData.append("allowedFileTypes", ['.jpg', '.png', '.gif'])
    }

    updateUploadedImages() {
        this.state.images.map(image => {
            // Create the mock file:
            let mockFile = {
                name: image.attributes?.originalFileName || "",
                size: image.attributes?.size,
                xhr: {
                    response: JSON.stringify(image),
                }
            };
            mockFile.status = this.dropZone.ADDED;
            mockFile.accepted = true;
            // Call the default addedfile event handler
            this.dropZone.emit("addedfile", mockFile);
            // And optionally show the thumbnail of the file:
            this.dropZone.emit("thumbnail", mockFile, image.attributes?.publicUrl);
            // Make sure that there is no progress bar, etc...
            this.dropZone.emit("complete", mockFile);
            // If you use the maxFiles option, make sure you adjust it to the
            // correct amount:
            this.dropZone.options.maxFiles = this.dropZone.options.maxFiles - 1;
        })
    }

    initDropZone(dropZone) {
        this.dropZone = dropZone
        this.updateUploadedImages()
        this.dropZone.on("success",(file)=>{
            if(this.props.images.length>this.maxFiles){
                this.dropZone.removeFile(file)
            }
        })
    }

    maxFilesExceeded(file) {
        this.dropZone.removeFile(file)
    }

    render() {
        const componentConfig = {
            iconFiletypes: ['.jpg', '.png', '.gif'],
            allowedFiletypes: ['.jpg', '.png', '.gif'],
            showFiletypeIcon: this.state.showFiletypeIcon,
            postUrl: this.state.accountId ? `/accounts/${this.state.accountId}/upload/images` :
                AppContext.addApiKeysAsQueryParametersToPath('/upload-images'),
        }

        const djsConfig = {
            autoProcessQueue: true,
            addRemoveLinks: true,
            maxFiles: this.maxFiles,
            dictDefaultMessage: '',
        }
        const eventHandlers = {
            success: this.addedFile,
            sending: this.sending,
            removedfile: this.removedFile,
            init: this.initDropZone,
            maxfilesexceeded: this.maxFilesExceeded,
        }

        return (
            <DropzoneComponent config={componentConfig}
                eventHandlers={eventHandlers}
                djsConfig={djsConfig} />
        );
    }
}

export default ImageUploaderDropZone





// WEBPACK FOOTER //
// ./src/common/image-uploader/dropzone.component.jsx